// Footprint never exceeds a unit circle: a radius-r collider encloses every face.
// The high, offset apex reads as a sharp stone rather than a rounded boulder.
export const POINTED_ROCK_VERTICES = [];
export const POINTED_ROCK_FACES = [];
for(let i=0;i<6;i++){
 const a=i*Math.PI/3,r=i%2?1:.88;
 POINTED_ROCK_VERTICES.push([Math.cos(a)*r,0,Math.sin(a)*r]);
}
for(let i=0;i<6;i++){
 const a=i*Math.PI/3,r=i%2?.49:.57;
 POINTED_ROCK_VERTICES.push([Math.cos(a)*r+.07,.47+(i%3)*.09,Math.sin(a)*r-.04]);
}
POINTED_ROCK_VERTICES.push([.17,2.10,-.13]);
for(let i=0;i<6;i++){
 const j=(i+1)%6;
 POINTED_ROCK_FACES.push([i,6+i,j],[j,6+i,6+j],[6+i,12,6+j]);
}
// The bottom fan is hidden just below the sand.
for(let i=1;i<5;i++)POINTED_ROCK_FACES.push([0,i+1,i]);
